import * as Sentry from '@sentry/nuxt'
import type { RouteLocationRaw } from 'vue-router'

export default function useAuth() {
  const account = useState<components['schemas']['Account'] | null>(
    'auth_account',
    () => null
  )
  const isAuthenticated = computed<boolean>(() => !!account.value)

  const logout = async (to?: RouteLocationRaw) => {
    const { $api } = useNuxtApp()

    await $api('/account/logout/', {
      method: 'POST',
    }).then(async () => {
      const { fullPath } = useRoute()

      Sentry.setUser(null)
      clearNuxtState()
      sessionStorage.clear()

      if (fullPath === to) {
        reloadNuxtApp()
      } else {
        await navigateTo(to ?? { name: 'index' })
      }
    })
  }

  const setAccount = async () => {
    const { $api } = useNuxtApp()
    await $api<components['schemas']['Account']>('/account/')
      .then((response) => {
        if (!response) return
        account.value = response

        const userPayload = {
          id: response.id,
          email: response.email,
          username: response.email,
        }

        Sentry.setUser(userPayload)
      })
      .catch(() => (account.value = null))
  }

  return {
    account,
    isAuthenticated,
    logout,
    setAccount,
  }
}
